module.exports = __webpack_public_path__ + "static/media/pumpkin.62911b4d.glb";